import { ReactNode } from "react";
import { Sidebar } from "./Sidebar";
import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";

interface LayoutProps {
  children: ReactNode;
  title: string;
  logo?: ReactNode;
  sidebarContent?: ReactNode;
  hasSidebar?: boolean;
  navbarContent?: ReactNode;
  footerContent?: ReactNode;
}

export const Layout = ({
  title,
  children,
  sidebarContent,
  logo,
  navbarContent,
  footerContent,
  hasSidebar = false,
}: LayoutProps) => {
  return (
    <div className="h-full">
      <div className="flex">
        {hasSidebar && (
          <Sidebar logo={logo}>
            {sidebarContent || (
              <nav className="space-y-2">
                <div className="p-2 rounded cursor-pointer hover:bg-gray-100">
                  Strona główna
                </div>
                <div className="p-2 rounded cursor-pointer hover:bg-gray-100">
                  Raporty
                </div>
                <div className="p-2 rounded cursor-pointer hover:bg-gray-100">
                  Ustawienia
                </div>
              </nav>
            )}
          </Sidebar>
        )}
        <div
          className={
            hasSidebar
              ? "desktop:ml-[300px] desktop:w-[calc(100%-300px)] w-full print:ml-0 print:w-full"
              : "w-full"
          }
        >
          {navbarContent ? navbarContent : <Header title={title} />}
          <main>{children}</main>
          {footerContent ? footerContent : <Footer />}
        </div>
      </div>
    </div>
  );
};
